import { MutableRefObject } from 'react';
import { ID } from 'types';

interface GetHeaderIDParams {
  headerMap: ID[];
  hotRef: MutableRefObject<any>;
}

// returns the key of the currently selected column header
export const getHeaderID = ({ headerMap, hotRef }: GetHeaderIDParams): ID | undefined => {
  if (!hotRef.current?.hotInstance) return undefined;

  // Returns indexes of the currently selected cells as an array of arrays [[startRow, startCol, endRow, endCol],...].
  //  `startRow` = -1 when the user is clicking on the header row with the column names
  //  `startCol` & `endCol` = the index of the column which is selected (not including the lot/row number column)
  //  `endRow` = the total number of line item rows (index starts at 0)
  const selected = hotRef.current?.hotInstance.getSelected();

  // Unsure when selected[0].length would be less than 2?
  if (!selected?.length || selected[0].length < 2) return undefined;

  // selected[0][1] is the index of the column header that is currently selected
  const column = selected[0][1];

  if (column === undefined || column < 0) return undefined;

  // Return the header ID for the selected column by passing in the column index
  return headerMap[column];
};
